import React from 'react'
import SvgSrc from './img/jewish-ru-logo.inline.svg'

export default function () {
  return <SvgSrc />
}